module.exports = __webpack_public_path__ + "static/media/west.239e5e6b.png";